import { Mapping } from '@/views/modules/absences/utils/types';
import { ABSENCE_COLORS } from '@/views/modules/absences/config/constants';

export function getRecordStyling(item, mappings: Mapping[]) {
  const result = {
    style: {} as any,
    class: 'absence-interval',
  };
  if (!mappings) {
    return result;
  }
  mappings.forEach((mapping) => {
    const fieldValue = item[mapping.field];
    if (!mapping.colorMap) {
      return;
    }
    const colorValue = mapping.colorMap[fieldValue];
    if (!colorValue) {
      return;
    }

    if (mapping.mapType === 'color') {
      result.class = `${result.class} ${colorValue}`;
      const backgroundColor = ABSENCE_COLORS[colorValue] || colorValue;
      result.style.backgroundColor = backgroundColor;
    }
    if (mapping.mapType === 'border') {
      result.class = `${result.class} border-interval`;
      result.style.borderColor = colorValue;
    }
    if (mapping.mapType === 'pattern') {
      result.class = `${result.class} pattern-interval pattern-${colorValue}`;
    }
  });
  if (!result.style.backgroundColor) {
    result.class = `${result.class} interval-default`;
  }
  return result;
}

export function getValueStyling(value: string, mappings: Mapping[]) {
  // eslint-disable-next-line no-param-reassign
  mappings = Array.isArray(mappings) ? mappings : [mappings];
  const result = {
    style: {} as any,
    class: 'absence-interval',
  };
  if (!mappings) {
    return result;
  }
  mappings.forEach((mapping) => {
    const fieldValue = value;
    if (!mapping.colorMap) {
      return;
    }
    const colorValue = mapping.colorMap[fieldValue];
    if (!colorValue) {
      return;
    }

    if (mapping.mapType === 'color') {
      result.class = `${result.class} ${colorValue}`;
      const backgroundColor = ABSENCE_COLORS[colorValue] || colorValue;
      result.style.backgroundColor = backgroundColor;
      result.style.color = 'white';
    }
    if (mapping.mapType === 'border') {
      result.class = `${result.class} border-interval`;
      result.style.borderColor = colorValue;
    }
    if (mapping.mapType === 'pattern') {
      result.class = `${result.class} pattern-interval pattern-${colorValue}`;
    }
  });
  if (!result.style.backgroundColor) {
    result.class = `${result.class} interval-default`;
  }
  return result;
}

export function getButtonStyling(value: string, mapping: Mapping) {
  const result = {
    style: {} as any,
    class: '',
  };
  if (mapping.mapType === 'color') {
    result.class = `${result.class} ${value}`;
    const backgroundColor = ABSENCE_COLORS[value] || value;
    result.style = {
      backgroundColor,
      color: 'white',
    };
  }
  if (mapping.mapType === 'pattern') {
    result.class = `${result.class} pattern-${value}`;
  }
  if (mapping.mapType === 'border') {
    result.class = `${result.class} calendar-border`;
    const borderColor = ABSENCE_COLORS[value] || value;
    result.style = {
      backgroundColor: 'transparent',
      borderColor,
      borderWidth: '2px',
      borderStyle: 'solid',
    };
  }

  return result;
}
